var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Drawer',{attrs:{"isDrawerOpen":_vm.isDrawerOpen},on:{"toggle-drawer":_vm.toggleDrawer}}),_c('Navigation',{on:{"toggle-drawer":_vm.toggleDrawer}}),_c('router-view',{attrs:{"name":"client-view"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }